import { call, put } from 'redux-saga/effects';
import UserActions from '../redux/user'

const saveUserAction = function* saveUser({ user }) {
  console.log('saveUserAction - SAGA - user', user)
  yield put(UserActions.saveUserSuccess(user))
}

export const saveUser = saveUserAction
